export const categories = [
  {
    key: "action",
    name: "动作",
    en: "Action",
    icon: "ri-sword-fill",
    desc: "肾上腺素飙升的追车、爆破与硬核格斗，动作片爱好者不容错过的重磅之作。",
  },
  {
    key: "drama",
    name: "剧情",
    en: "Drama",
    icon: "ri-emotion-happy-line",
    desc: "聚焦人性与命运的深度叙事，细微之处见真章，值得静下心来慢慢品味。",
  },
  {
    key: "scifi",
    name: "科幻",
    en: "Sci-Fi",
    icon: "ri-planet-line",
    desc: "从星际远征到人工智能觉醒，想象力构筑的未来图景在此一一展开。",
  },
  {
    key: "romance",
    name: "爱情",
    en: "Romance",
    icon: "ri-heart-3-line",
    desc: "关于相遇、错过与重逢的温柔故事，适合在某个夜晚静静观赏。",
  },
  {
    key: "mystery",
    name: "悬疑",
    en: "Mystery",
    icon: "ri-spy-line",
    desc: "层层反转的推理与心理博弈，真相往往藏在最不起眼的细节里。",
  },
  {
    key: "comedy",
    name: "喜剧",
    en: "Comedy",
    icon: "ri-emotion-laugh-line",
    desc: "轻松解压的幽默佳作，让笑声化解一整天疲惫的观影首选。",
  },
  {
    key: "animation",
    name: "动画",
    en: "Animation",
    icon: "ri-magic-line",
    desc: "用笔触与色彩搭建的奇妙世界，全年龄向的想象力盛宴。",
  },
  {
    key: "horror",
    name: "恐怖",
    en: "Horror",
    icon: "ri-ghost-line",
    desc: "黑暗深处的未知恐惧，胆大者专属的心跳体验，请谨慎选择观影环境。",
  },
];